<template>
    <div>
        <create-dialog :value="dialog"
        @close-dialog="dialog=false, item=null"
        :item="item" @fetchData="fetchData" @setSelect="setSelect"></create-dialog>
        <v-card>
            <v-toolbar color="white" flat>
                <v-toolbar-title class="mx-4">Danh sách phiếu</v-toolbar-title>
                <v-spacer></v-spacer>
                
                <!-- //actions -->
                <v-menu
                    left
                    bottom offset-y
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn outlined color="success" class="ml-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            Hành động<v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                    <v-list-item @click="dialog=true">
                        <v-list-item-title>Thêm phiếu <v-icon color="primary" right>mdi-plus</v-icon></v-list-item-title>
                    </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar>
            
            <v-card-title>
                <v-row justify="start">
                    <!-- <v-col cols="12" md="2">
                        <v-dialog
                            ref="monthDialog"
                            :return-value.sync="month"
                            persistent
                            width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field outlined dense 
                                v-model="month"
                                label="Chọn tháng *"
                                prepend-icon="mdi-calendar"
                                readonly hide-details
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker dense locale="vi"
                            v-model="month"
                            type="month"
                            scrollable
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.monthDialog.save(month)"
                            >
                                Chọn
                            </v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col> -->
                    <v-col cols="12" md="12">
                        <v-text-field v-model="globalSearch" hide-details outlined dense full-width
                             placeholder="Tìm kiếm" persistent-placeholder label="Tìm mã phiếu" ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12" md="2">
                        <v-select v-model="filterStatus" hide-details outlined dense :items="['Mới', 'Đã nhận', 'Hoàn thành', 'Chối từ']" clearable
                             placeholder="Tìm kiếm tên, chi nhánh" persistent-placeholder label="Tìm mã phiếu" ></v-select>
                    </v-col> -->
                    <!-- <v-col cols="12" md="2">
                        <v-text-field v-model="search" hide-details outlined dense
                             placeholder="Tìm kiếm tên, chi nhánh" persistent-placeholder label="Tìm chi nhánh" ></v-text-field>
                    </v-col> -->
                    <!-- <v-col cols="12" md="2">
                        <v-text-field v-model="filterDepartment" hide-details outlined dense
                             placeholder="Tìm kiếm chi nhánh" persistent-placeholder label="Tìm kiếm chi nhánh" ></v-text-field>
                    </v-col> -->
                </v-row>
            </v-card-title>
        </v-card>
        <v-row class="mt-5">
            <v-col cols="12" md="4">
                <v-card>
                    <v-card-title>Danh sách bộ câu hỏi</v-card-title>
                    <v-data-table :items="items1" :headers="headers1"  height="calc(100vh - 300px)" 
                    :search="globalSearch" single-select show-select item-key="id" v-model="item1Select">
                        <template v-slot:[`item.actions`]="{item}" >
                            <v-menu dense
                                left
                                bottom offset-y
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary" x-small
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        Thao tác<v-icon>mdi-chevron-down</v-icon>
                                    </v-btn>
                                </template>

                                <v-list>
                                    
                                    <v-list-item @click="edit(item.id)" dense>
                                        <v-list-item-icon>
                                            <v-icon color="primary">mdi-cursor-text</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>Chi tiết </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="exportTemplate(item)" dense>
                                        <v-list-item-icon>
                                            <v-icon color="green">mdi-microsoft-excel</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>Xuất file</v-list-item-title>
                                    </v-list-item>
                                    
                                    <v-list-item @click="publish(item.id)" dense>
                                        <v-list-item-icon>
                                            <v-icon color="warning">mdi-earth-arrow-right</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>{{item.isPublished ==1 ? 'Thu hồi' : 'Xuất bản'}}</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="dialogDelete=true, targetItem=item.id" dense>
                                        <v-list-item-icon>
                                            <v-icon color="error">mdi-delete</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>Xóa</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                            <!-- <edit-button @click="edit(item)"></edit-button>
                            <delete-button @click="deleteItem(item)"></delete-button> -->
                        </template>

                        <template v-slot:[`item.isPublished`]="{item}" >
                            <v-icon color="success" v-if="item.isPublished==1">mdi-check</v-icon>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
            
            <v-col cols="12" md="8">
                <v-card>
                    <v-card-title>Chi tiết template ID: {{selectedTemplate}}
                        <v-spacer></v-spacer>
                        <v-btn outlined color="red" class="mx-2" :to="{ name: 'SurveyReport', params: {id: Number(selectedTemplate)} }"><v-icon left>mdi-chart-line</v-icon> Thống kê </v-btn>
                        <v-dialog v-model="questionDialog" width="500" persistent>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn outlined color="success" v-bind="attrs" v-on="on" :disabled="item1Select==0">
                                    Tạo câu hỏi
                                </v-btn>
                            </template>

                            <v-card>
                                <v-card-title>Câu hỏi
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click="closeQuestion"><v-icon>mdi-close</v-icon></v-btn>
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-select outlined hide-details="auto" :items="questionTypes" label="Loại câu hỏi" v-model="question.type"></v-select>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-textarea outlined hide-details="auto" label="Nhập câu hỏi" v-model="question.name"></v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-title v-if="question.type != 'TEXT'">Câu trả lời</v-card-title>
                                <v-card-text v-if="question.type != 'TEXT'">
                                    <v-data-table
                                        :headers="answerHeader"
                                        :items="answers"
                                        flat
                                    >
                                        <template slot="top" slot-scope="props">
                                            <v-textarea auto-grow rows="3" flat outlined solo label="" v-model="answer" @keydown.enter.prevent="addAnswer" hide-details placeholder="Ấn enter thêm câu trả lời">
                                                <template slot="append">
                                                    <v-btn icon><v-icon color="primary">mdi-table-plus</v-icon></v-btn>
                                                </template>
                                            </v-textarea>
                                        </template>

                                        <template slot="item.actions" slot-scope="props">
                                            <v-btn color="error" outlined small @click="deleteAnswer(props.index)"> <v-icon left>mdi-delete</v-icon> Xóa</v-btn>
                                        </template>
                                    </v-data-table>
                                </v-card-text>

                                <v-divider></v-divider>

                                <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="teal darken-4" dark
                                    @click="saveQuestion"
                                >
                                    <v-icon left>mdi-floppy</v-icon>
                                    Lưu
                                </v-btn>
                                <v-spacer></v-spacer>
                                </v-card-actions>
                            </v-card>
                            </v-dialog>
                    </v-card-title>

                    <!-- datatable -->
                    <v-data-iterator
                    :items="questions"
                    no-data-text="Không có dữ liệu"
                    >

                    <template v-slot:default="props">
                       <v-card class="rounded-xl ma-6" outlined 
                        v-for="item in props.items"
                        :key="item.id"
                        >
                            <v-card-title>
                                {{item.question.name}}
                                <v-spacer></v-spacer>
                                <v-btn icon @click="changeQuestionOrder(item.question.id, 'UP')"><v-icon >mdi-arrow-up</v-icon></v-btn>
                                <v-btn icon @click="changeQuestionOrder(item.question.id, 'DOWN')"><v-icon >mdi-arrow-down</v-icon></v-btn>
                                <v-btn icon @click="deleteQuestion(item.question.id)"><v-icon color="">mdi-close</v-icon></v-btn>
                            </v-card-title>
                            <v-card-text v-if="item.question.type == 'TEXT'">
                                <v-row>
                                    <v-col cols="12">
                                        <v-textarea placeholder="Nhập câu trả lời"></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            
                            <v-card-text v-if="item.question.type == 'OPTION'">
                                <v-row>
                                    <v-col cols="8">
                                        <v-radio-group>
                                            <v-radio v-for="iAnswer in item.answers" :key="iAnswer.id">
                                                <template v-slot:label>
                                                    {{iAnswer.name}}
                                                    <v-spacer></v-spacer>
                                                    <span><b>Đã chọn: </b> {{iAnswer.selected}}</span>
                                                </template>
                                            </v-radio>
                                        </v-radio-group>
                                    </v-col>
                                    <v-col cols="4">

                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <v-card-text v-if="item.question.type == 'MULTI_OPTION'">
                                <v-row>
                                    <v-col cols="8">
                                        <v-checkbox v-for="iAnswer in item.answers" :key="iAnswer.id">
                                            <template v-slot:label>
                                                {{iAnswer.name}}
                                                <v-spacer></v-spacer>
                                                <span><b>Đã chọn: </b> {{iAnswer.selected}}</span>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="4">

                                    </v-col>
                                </v-row>
                            </v-card-text>
                       </v-card>
                    </template>
                    </v-data-iterator>
                </v-card>
            </v-col>
        </v-row>
        <!-- ************** DELETE CONFIRMATION *************** -->
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="headline">Bạn có chắc muốn xoá dữ liệu này? ID: {{targetItem}}</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="dialogDelete=false">Thoát</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteTemplate">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="loadingDialog" width="300px" persistent>
            <v-card>
                <v-card-title class="text-center">
                    <v-spacer></v-spacer>
                    Đang xuất file
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text class="text-center">
                    <v-progress-circular
                    size="70"
                    indeterminate
                    color="orange"
                    ></v-progress-circular>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import CreateDialog from './Create.vue';
import http from '@/components/services/http-common';
import moment from 'moment/moment';
import api from './services/api.js'

export default {
    components:{
        "create-dialog": CreateDialog,
    },
    computed: {
        selectedTemplate() {
            let rslt = this.item1Select.length>0 ? ` ${this.item1Select[0].id }`: ""

            return rslt
        }
    },
    watch:{
        dialog(val) {
            if(!this.dialog)
                this.item=null;
        },
        month(val)
        {
            this.fetchData();
        },
        item1Select() {
            if(this.selectedTemplate != ""){
                this.getQuestions()
            } else{
                this.questions=[]
            }
        }
    },
    data () {
        return {
            month: moment().startOf("months").format("yyyy-MM"),
            item: null,

            item1Select: [],
            items1:[],
            items2:[],
            search:"",

            filterCode:"", 
            filterStatus:"", 
            filterDepartment:"", 
            currentItem: "",

            loadingDialog: false,
            globalSearch:"",
            headers1: [
                {text:"Thao tác", value: "actions", width:"100px"},
                {text:"Id", value: "id", width:"100px"
                },
                {text:"Tên khảo sát", value: "name", width:"7rem"                },
                {text: 'Xuất bản', value: 'isPublished', width: '200px'}
            ],
            
            headers2: [
                {text:"Thao tác", value: "actions", width:"7rem"},
                {text:"Id", value: "id", width:"7rem", 
                    filter: value => {
                        if (!this.filterCode) return true
            
                        return value.toUpperCase().includes(this.filterCode.toUpperCase())
                    },
                },
                {text:"Tên khảo sát", value: "name", width:"7rem", 
                    filter: value => {
                        if (!this.filterCode) return true
            
                        return value.toUpperCase().includes(this.filterCode.toUpperCase())
                    },
                },
            ],

            questionTypes: [
                {text: "Tự luận", value: "TEXT"},
                {text: "Lựa chọn", value: "OPTION"},
                {text: "Nhiều lựa chọn", value: "MULTI_OPTION", disabled: false},
            ],
            question:{
                type: "OPTION",
                name:"",
            },
            questions:[],

            answerHeader:[
                {text:"Câu trả lời", value:"name"},
                {text:"Xóa", value:"actions", width: 150}

            ],
            answers: [],
            answer:"",

            dialogDelete: false,
            targetItem: null,
            dialog: false,
            questionDialog:false,
        }
    },
    methods: {
        fetchData() {
            return this.apiService.getTemplates().then(d => {
                this.items1 = d.data
            })
        },
        setSelect(e)
        {
            this.item= {code : e};
        },
        
        edit(item){
            this.item = item;
            this.dialog = true;
        },
        publish(item) {
            this.apiService.publishTemplate(item).then(() => this.fetchData())
        },

        deleteItem(item) {
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            let url = `propertyRequests/${this.targetItem.code}`;
            return http.delete(url).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            }).catch(err => {
                switch (err.response.status)
                {
                    case 403:{
                        this.unauthorizeAlert();
                        this.dialogDelete = false;
                        break;
                    }
                    default:
                        break;
                }
            })
        },

        //template
        deleteTemplate() {
            return this.apiService.deleteTemplate(this.targetItem).then(()=> {
                this.targetItem=undefined
                this.dialogDelete = false
                this.fetchData()
            })
        },
        
        exportTemplate(item){
            try {
                this.loadingDialog = true
                return http.get("surveys/"+item.id+"/export", {
                    params: {
                        month: moment(this.month).format('YYYY-MM-DD')
                    },
                    responseType: 'blob',
                }).then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `EXPORT_KHAO_SAT${moment(this.month, 'yyyy-MM-dd').format("MM-YYYY")}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                }).finally(()=> {
                    this.loadingDialog=false
                });
            } catch(e){
                alert(e)
            }
        },

        ///QUESTION
        closeQuestion() {
            this.questionDialog = false
            this.answers = []
            this.answer = ""
            this.question.name = ""
            this.question.type = "OPTION"
        },
        getQuestions() {
            try{
                return this.apiService.getQuestions(this.selectedTemplate).then(d => {
                    this.questions = d.data
                })
            }catch(e)
            {
                alert(e)
            }
        },
        saveQuestion(){
            let mappedAnswer = this.answers.map(x=>x.name)
            let postData = {
                name: this.question.name,
                type: this.question.type,
                answers: mappedAnswer
            }
            return this.apiService.postQuestion(this.selectedTemplate, postData).then(() => {
                this.closeQuestion()
                return this.getQuestions()
            })
        },
        deleteQuestion(id) {
            return this.apiService.deleteQuestion(this.selectedTemplate, id).then(() => {
                return this.getQuestions()
            })
        },
        changeQuestionOrder(id, mode) {
            return this.apiService.changeQuestionOrder(this.selectedTemplate, id, mode).then(() => {
                return this.getQuestions()
            })
        },

        /// ANSWER
        addAnswer() {
            this.answers.push({name: this.answer});
            this.answer="";
        },
        deleteAnswer(index) {
            // let index = this.answers.findIndex(obj => obj.name === name);
            if (index !== -1) {
            let removedObject = this.answers.splice(index, 1); // Remove the object from the array
            } else {
                alert('Object not found in the array.');
            }
        }
    },

    apiService: null,
    created() {
        this.apiService = new api()
    },
    mounted () {
        this.fetchData();
    }
}
</script>